/** Emojis rápidos para reação (estilo WhatsApp). */
export const TEAM_QUICK_REACTIONS = ["👍", "❤️", "😂", "😮", "😢", "🙏", "✅"];

export function teamMessageSnippet(msg, { maxLen = 140, t } = {}) {
  if (!msg) return "";
  const type = msg.messageType;
  if (type === "image" || msg.imageUrl) return t?.("snippetImage") || "📷 Imagem";
  if (type === "video" || msg.videoUrl) return t?.("snippetVideo") || "🎬 Vídeo";
  if (type === "audio" || msg.audioUrl) return t?.("snippetAudio") || "🎤 Áudio";
  if (type === "file" || msg.fileUrl) {
    const name = msg.fileName || t?.("snippetFile") || "Arquivo";
    return `📎 ${name}`;
  }
  if (
    msg.metadata?.xpro_team_video_invite ||
    msg.metadata?.xpro_video_invite ||
    msg.metadata?.xpro_video_call_summary ||
    msg.metadata?.xpro_video_call_transcript ||
    msg.metadata?.xpro_video_recording ||
    /\/video\//i.test(String(msg.content || ""))
  ) {
    if (msg.metadata?.xpro_video_call_summary || msg.metadata?.xpro_team_video_invite) {
      return t?.("snippetVideoSummary") || "📹 Chamada da equipe";
    }
    if (msg.metadata?.xpro_video_call_transcript) {
      return t?.("snippetVideoTranscript") || "📝 Transcrição da chamada";
    }
    return t?.("snippetVideoCall") || "📹 Chamada de vídeo";
  }
  const text = String(msg.content || "").trim();
  if (!text) return t?.("snippetEmpty") || "(Sem texto)";
  return text.length > maxLen ? `${text.slice(0, maxLen)}…` : text;
}

export function buildForwardMetadata(msg, space) {
  if (!msg) return null;
  return {
    forwardedFrom: {
      messageId: msg.id,
      spaceId: msg.spaceId || space?.id,
      spaceName: space?.name || space?.slug || "",
      authorName: msg.authorName || "",
      authorType: msg.authorType,
      content: msg.content || "",
      messageType: msg.messageType || "text",
      imageUrl: msg.imageUrl || null,
      videoUrl: msg.videoUrl || null,
      audioUrl: msg.audioUrl || null,
      fileUrl: msg.fileUrl || null,
      fileName: msg.fileName || null,
    },
  };
}

export function buildForwardSendPayload(msg, { caption = "" } = {}) {
  const meta = buildForwardMetadata(msg);
  const cap = String(caption || "").trim();
  const type = msg?.messageType || "text";

  if (type === "image" && msg.imageUrl) {
    return {
      content: cap,
      messageType: "image",
      imageUrl: msg.imageUrl,
      metadata: meta,
    };
  }
  if (type === "video" && msg.videoUrl) {
    return {
      content: cap,
      messageType: "video",
      videoUrl: msg.videoUrl,
      metadata: meta,
    };
  }
  if (type === "audio" && msg.audioUrl) {
    return {
      content: cap,
      messageType: "audio",
      audioUrl: msg.audioUrl,
      metadata: meta,
    };
  }
  if (type === "file" && msg.fileUrl) {
    return {
      content: cap || msg.fileName || " ",
      messageType: "file",
      fileUrl: msg.fileUrl,
      fileName: msg.fileName,
      metadata: meta,
    };
  }

  const snippet = teamMessageSnippet(msg);
  return {
    content: cap || snippet,
    messageType: "text",
    metadata: meta,
  };
}

/** Resolve alvo de navegação ao clicar em citação de resposta ou encaminhamento. */
export function resolveTeamQuotedNavigationTarget({ replyPreview, replyToId, forwardedFrom, spaceId }) {
  if (replyPreview?.id != null || replyToId != null) {
    const messageId = Number(replyPreview?.id ?? replyToId);
    if (!Number.isFinite(messageId)) return null;
    return {
      messageId,
      spaceId: spaceId != null ? Number(spaceId) : null,
    };
  }

  if (forwardedFrom?.messageId != null) {
    const messageId = Number(forwardedFrom.messageId);
    if (!Number.isFinite(messageId)) return null;
    return {
      messageId,
      spaceId:
        forwardedFrom.spaceId != null ? Number(forwardedFrom.spaceId) : null,
    };
  }

  return null;
}

export const TEAM_SCROLL_TO_MESSAGE_STORAGE_PREFIX = "team-scroll-msg:";

export function storeTeamScrollToMessage(spaceId, messageId) {
  if (spaceId == null || messageId == null) return;
  try {
    sessionStorage.setItem(
      `${TEAM_SCROLL_TO_MESSAGE_STORAGE_PREFIX}${spaceId}`,
      String(messageId)
    );
  } catch {
    /* ignore */
  }
}

export function consumeTeamScrollToMessage(spaceId) {
  if (spaceId == null) return null;
  try {
    const key = `${TEAM_SCROLL_TO_MESSAGE_STORAGE_PREFIX}${spaceId}`;
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    sessionStorage.removeItem(key);
    const messageId = Number(raw);
    return Number.isFinite(messageId) ? messageId : null;
  } catch {
    return null;
  }
}

export function groupReactions(reactions = []) {
  const map = new Map();
  for (const r of reactions || []) {
    const emoji = String(r?.emoji || "").trim();
    const uid = Number(r?.userId);
    if (!emoji) continue;
    if (!map.has(emoji)) map.set(emoji, []);
    map.get(emoji).push({
      userId: uid,
      userName: r?.userName || "",
    });
  }
  return [...map.entries()].map(([emoji, users]) => ({ emoji, users, count: users.length }));
}
